import { getFileObjectFromStorage } from './getFileObjectFromStorage';

// Request URLs
declare const API_URL: string;
declare const REST_API_URL: string;
export const GRAPHQL_URL = `${API_URL}graphql/`;
export const REST_URL = `${REST_API_URL}api/`;

export { getFileObjectFromStorage };
